const languageDirections = {
  ltr: "ltr",
  rtl: "rtl",
};

export { languageDirections };
